export default {
  local: 'zh-hk',

  role: { //  all belongs to "membership" collection
    member: '會員', //  can login
    cashier: "收銀", //  sub-set of npc , used in ecommerce
    npc: '系統賬號', //  non-person character ( represent admin in membership collections, used in notification and appointment : assign caregiver )
    admin: '管理員',
    superadmin: '超級管理員',
  },

  type: {
    login: {
      fb: 'fb',
      wechat: 'wechat',
      emailPwd: 'emailPwd',
    },
    temp_token: {
      forget_password: 'forget_password',
      verifyEmail: 'verifyEmail',
    },
    mediaProfile: {
      png: 'png',
      jpg: 'jpg',
    },
    notification_type: {
      appointment: "appointment",
    },
    notification_sub_type: {
      //  appointment
      new_appointment: "new_appointment",
      new_urgent_appointment: "new_urgent_appointment",
      job_notice_for_caregiver: "job_notice_for_caregiver",

      no_suitable_candidates: "no_suitable_candidates",
      no_caregiver_confirm: "no_caregiver_confirm",
      cancelled_by_client: "cancelled_by_client",
      accepted_by_caregiver: "accepted_by_caregiver",
      cancelled_by_caregiver: "cancelled_by_caregiver",
    },
    transaction: {
      purchase: '購買',
      penalty: '罰款',
      refund: '退款',
      extra_pay: '附加費',
      standalone: '獨立交易',
      rapid: '快速付款',
      caregiver_invoice: '${i18n.schema.caregiver}${i18n.schema.invoice}',
    },
    coupon: {
      one_time: "一次",   //  each member can only use the coupon once
      unlimited_time: "無限",   //  ignore expiry day checking
    },
    feedback: {
      admin_to_caregiver: '管理員評價護理員',
      admin_to_client: '管理員評價客戶',
      client_appointment_feedback: '客戶評價',
      client_to_caregiver: '客戶評價',
      caregiver_appointment_feedback: '護理員評價',
    },
  },

  status: {
    // system: {
    inactive: '停用',
    active: '啟用',
    deleted: '已删除', //  by admin
    archived: '已封存', //  by member
    // },
    // verification: {
    not_verified: '未驗證',
    verified: '已驗證',
    // },
    // payment: {
    success: '成功',
    failed: '失敗',
    // },
    // commentBox: {
    enabled: '啟用',
    disabled: '停用',
    // },
    // appointment_progress_status: {
    waiting_admin_approve: '等待管理員批准',
    matching_helper: '配對護理員中',
    waiting_helper_confirm: "等待護理員確認", //  * either assigned by admin or system
    waiting_admin_confirm: '等待管理員確認',
    confirmed: '已確認', //  * caregivers accepted
    in_progress: '進行中',     //  if not accepted, will not change to in_progress
    waiting_review: '等待評價',
    waiting_client_feedback: '等待客戶評價',
    waiting_helper_feedback: '等待護理員評價',
    completed: '完成',
    incomplete: '未完成', //  will not count as used
    cancelled_by_sender: '發出者已取消',
    // },
    // potential_helper_status: {
    pending: "待處理",
    accepted: "接受", //  previous status : pending
    rejected: "拒絕", //  previous status : pending
    cancelled: "取消", //  previous status : accepted
    approved: '已批准',

    arrived: '已到達',
    left: '已離開',
    reported: '已回報工作',
    feedbacked: '已提交反饋',
    send_invoice: '已發出收據',
    invoice_sent: '已發出收據',
    complete: '完成',
    absent: '缺席',
    late: '遲到',
  },
  gender: {
    m: '男',
    f: '女',
  },

  alert: {
    html: {
      cannot_fetch_item_$err: '<span>無法取得資料：${err}</span>',
      cannot_fetch_list_$err: '<span>無法取得列表：${err}</span>',
      $err: '<span>${err}</span>',
      record_updated_successfully: '<span>已成功更新</span>',
      record_saved_successfully: '<span>已儲存</span>',
      file_uploaded_successfully: '<span>已成功上載</span>',
      no_subprofile: '沒有服務對象',
      no_subprofile_desc: '該會員沒有登記任何服務對象，清先建立一個。',
      confirm_force_assign_job_to_this_member: '確定要指定工作給這個會員？',
      confirm_force_assign_job_to_this_member_ignore_accepted: '已經有別的會員接受了這個預約，仍然要强制指定？',
      time_clash_$appointments: '檢測到該會員有其他預約的緩衝時間上發生衝突：<br/><ul>${appointments.map(function(x){return "<li>" + x + "</li>"})}</ul><br/>仍然要指定？',
      not_available_days_$days: '護理員在該時段沒有空：<br/><ul>${days.map(function(x){return "<li>" + x + "</li>"})}</ul><br/>仍然要指定？',
      confirm_delete_$str: '確認刪除${str}？',
      confirm_action_$action: '確認${action}？',
      update_linked_subprofile: `
此動作會更新：<br/>
<ul>
    <li>此次\${i18n.schema.appointment}的\${i18n.schema.subprofile}</li>
    <li>以後建立的\${i18n.schema.appointment}的\${i18n.schema.subprofile}</li>
    <li>以後建立的\${i18n.schema.orders}的\${i18n.schema.subprofile}</li>
</ul><br/>
確定繼續？`,
      update_subprofile: '此動作會更新此次${i18n.schema.appointment}的${i18n.schema.subprofile}<br/>確定繼續？',
      confirm_complete_invoice: '確認完成${i18n.schema.invoice}？',
      warn_modify_status: '<span style="color: red">手動更改狀態可能影響正常系統流程，不建議使用。</span>',
    },
    empty_response: '無資料',
    invalid_response: '伺服器傳回無效的回應',
    please_choose_an_item_by_clicking_a_row: '請點擊一行以選擇一個項目。',
    force_assign_job_add_only: '要立即指定給該會員或是只加入候選名單？\n\n[確定]: 指定, [取消]: 加入候選名單',
  },
  html: {
    nil: '<small style="opacity: .5;"><i>&lt;無&gt;</i></small>',
    loading: '<i>${i18n.loading}</i>',
    not_found: '<i>找不到項目</i>',
    empty: '<i>&lt;無資料&gt;</i>',
  },
  loading: '載入中...',
  updated_at_$time: '於${time}更新',
  application_title: 'OkCare 管理平台',
  nil: '<無>',
  label_compulsory: '(强制性)',
  label_pick_a_month: '選擇月份',
  label_pick_a_profession: '選擇專業',
  create_schema_$name: '建立${name}',
  update_schema_$name: '更新${name}',
  schema_$name_details: '${name}詳細',
  admin: '管理員',
  // ecommerce: 'E-Commerce',
  pagination_footer: '顯示 ${total} 項中的第 ${from} 至 ${to} 項',
  search_placeholder: '搜尋...',
  search_records_placeholder: '搜尋項目',
  disk_usage: '儲存空間',
  ram_usage: '記憶體用量',
  cpu_usage: 'CPU 用量',
  revenue: '收入',
  revenue_$income_$refund: '收入：$${income}, 退款：$${refund}',
  cancelled_by_caregiver: '${i18n.schema.caregiver}已取消${i18n.schema.appointments}',
  complaint: '投訴',
  complaints: '投訴',
  not_interviewed: '未面試',
  appointment_requests_$total_$urgent: '${total} ${urgent ? "(" + urgent + " 緊急)" : ""}',
  pending_invoices: '待處理${i18n.schema.invoices}',
  no_name: '沒有姓名',
  menu: {
    overview: '概覽',
    members: '會員',
    appointments: '預約管理',
    ecommerce: '訂單管理',
    admin: '管理員',
    feedbacks: '反饋管理',
    notifications: '通知',
    systemconfigs: '系統設定',
    reports: '報表',
  },
  schema: {
    member: '會員',
    members: '會員',
    admin: '管理員',
    admins: '管理員',
    caregiver: '護理員',
    caregivers: '護理員',
    client: '客戶',
    clients: '客戶',
    subprofile: '服務對象',
    subprofiles: '服務對象',
    linked_subprofiles: '連結的服務對象供日後使用',
    group: '專業',
    groups: '專業',
    group_application: '專業資格申請',
    group_applications: '專業資格申請',
    group_apply: '申請專業資格',
    appointment: '預約',
    appointments: '預約',
    appointment_request: '${i18n.schema.appointment}申請',
    appointment_requests: '${i18n.schema.appointment}申請',
    order: '訂單',
    orders: '訂單',
    transaction: '交易',
    transactions: '交易',
    invoice: '收據',
    invoices: '收據',
    standalone_transaction: '獨立交易',
    rapid_payment: '快速付款',
    refund_transaction: '退款',
    payment: '付款',
    payments: '付款',
    product: '產品',
    products: '產品',
    service: '服務',
    services: '服務',
    coupon: '優惠券',
    coupons: '優惠券',
    feedback: '反饋',
    feedbacks_admin: '反饋 (管理員)',
    // feedbacks_admin_caregiver: '${i18n.type.feedback.admin_to_caregiver}',
    // feedbacks_admin_client: '${i18n.type.feedback.admin_to_client}',
    feedbacks_caregiver: '反饋 (夥伴)',
    feedbacks_client: '反饋 (客戶)',
    feedback_admin: '反饋 (管理員)',
    feedback_caregiver: '反饋 (夥伴)',
    feedback_client: '反饋 (客戶)',
    notification: '通知',
    notifications: '通知',
    systemnotification: '系統通告',
    systemnotifications: '系統通告',
    adminsendout: '管理員發出通知',
    adminsendouts: '管理員發出通知',
    email: '電郵',
    emails: '電郵',
    systemconfig: '系統設定',
    systemconfigs: '系統設定',
    enquiry: '查詢',
    enquiries: '查詢',
    enquiry_questionnaire: '問卷',
    enquiry_questionnaires: '問卷',
    log: '系統記錄',
    logs: '系統記錄',
    content: '内容',
    contents: '内容管理',
    // 'content-joinus-input_form': 'Join Us (input form)',
    // 'content-area-content': 'Area Content',
    // 'content-purchase-latest_booking': 'Purchase (latest booking)',
    // 'content-purchase-new_order': 'Purchase (new order)',
    // 'content-joinus-banner_top': 'Join Us (banner top)',
    // 'content-our_services_page-whyus_features': 'Our Services (why us - features section)',
    // 'content-our_services_page-overlabel': 'Our Services (over-label)',
    // 'content-our_services_page-banner_bottom': 'Our Services (banner bottom)',
    // 'content-our_services_page-download_top': 'Our Services (download top)',
    // 'content-our_services_page-whyus_middle': 'Our Services (why us - middle section)',
    // 'content-our_services_page-our_services_details': 'Our Services (details)',
    // 'content-content-faq': 'Faq',
    // 'content-aboutus-tri': 'About Us (tri)',
    // 'content-aboutus-bridge': 'About Us (bridge)',
    // 'content-aboutus-middle': 'About Us (middle)',
    // 'content-aboutus-plain_text': 'About Us (plain text)',
    // 'content-recruitment': 'Recruitment',
    post: '帖文',
    posts: '帖文',
  },
  fields: {
    display_name_$first_$last: '${last} ${first}',
    years_old_$yrs: '${yrs} 歲',
    array_item_$i: '第 ${i} 項',
    cat: {
      default: '其他',
      general: '一般',
      // client: '${i18n.schema.client}',
      // caregiver: '${i18n.schema.caregiver}',
      // subprofile: '${i18n.schema.subprofile}',
    },
    currency: {
      cash_hkd: '港幣',
      cash_rmb: '人民幣',
      cash_usd: '美金',
    },
    medical_histories: {
      disease: {
        heart_disease: 'Heart Disease',
        cancer: 'Cancer',
        hypertension: 'Hypertension',
        stroke: 'Stroke',
        diabetes: 'Diabetes',
        genetic_disease: 'Genetic Disease',
      },
      currentStatus: {
        stomach_throat: 'Stomach Throat',
        urinary_throat: 'Urinary Throat',
        bed_sores: 'Bed Sores',
        need_an_injection: 'Need an injection',
        wounds_after_surgery: 'Wounds after surgery',
      },
    },
    content_types: {
      appointment: '${i18n.schema.appointment}',
      membership: '${i18n.schema.member}',
      ecommerce: 'E-Commerce',
      system: '系統',
    },
    service_areas: {
      hki: '香港島',
      kl: '九龍',
      nt: '新界',
      isl: '離島',
    },
    roles: {
      member: '會員',
      admin: '管理員',
      superadmin: '超級管理員',
    },
    init_login_types: {
      emailPwd: '${i18n.fields.email}',
      sms: '${i18n.fields.phone}',
    },
    id: 'ID',
    member_id: '${i18n.schema.member}${i18n.fields.id}',
    subprofile_id: '${i18n.schema.subprofile}${i18n.fields.id}',
    // subprofile: '${i18n.schema.subprofile}',
    // subProfile: '${i18n.schema.subprofile}',
    // subprofiles: '${i18n.schema.subprofiles}',
    // subProfiles: '${i18n.schema.subprofiles}',
    group_id: '${i18n.schema.group}${i18n.fields.id}',
    // group: '${i18n.schema.group}',
    groups: '${i18n.schema.groups}',
    service_id: '${i18n.schema.service}${i18n.fields.id}',
    appointment_id: '${i18n.schema.appointment}${i18n.fields.id}',
    // appointment: '${i18n.schema.appointment}',
    // appointments: '${i18n.schema.appointments}',
    order_id: '${i18n.schema.order}${i18n.fields.id}',
    // order: '${i18n.schema.order}',
    // orders: '${i18n.schema.orders}',
    feedback_id: '${i18n.schema.feedback}${i18n.fields.id}',
    content_id: '${i18n.schema.content}${i18n.fields.id}',
    coupon_id: '${i18n.schema.coupon}${i18n.fields.id}',
    coupon_code: '${i18n.schema.coupon}編號 (區分大小寫)',
    notification_id: '${i18n.schema.notification}${i18n.fields.id}',
    transaction_id: '${i18n.schema.transaction}${i18n.fields.id}',
    // transaction: '${i18n.schema.transaction}',
    // transactions: '${i18n.schema.transactions}',
    product_id: '${i18n.schema.product}${i18n.fields.id}',
    // product: '${i18n.schema.product}',
    // products: '${i18n.schema.products}',
    payment_id: '${i18n.schema.payment}${i18n.fields.id}',
    // payment: '${i18n.schema.payment}',
    // payments: '${i18n.schema.payments}',
    email: '電郵',
    phone: '電話',
    phone_placeholder: '請輸入國際編號，i.e.：852xxxxxxxx',
    pwd: '密碼',
    role: '角色',
    timeslot: '時段',
    feature: '附加項目',
    created_at: '建立日期',
    updated_at: '更新日期',
    expired_at: '過期',
    status: '狀態',
    self_status: '狀態',
    tags: '標簽',
    type: '類別',
    // basicInfo_fulfilled: 'Basic info fulfilled',
    // email_fulfilled: 'Email fulfilled',
    init_login_type: '初始登錄類型',
    details: '詳細資料',
    verification: '驗證',
    activation_code: '激活碼',
    apply_group: '申請專業資格',
    finished_interview: '已完成面試',
    add_subprofile: '${i18n.action.add}${i18n.schema.subprofiles}檔案',
    my_subprofiles: '我的${i18n.schema.subprofiles}',
    my_appointments: '我的${i18n.schema.appointments}',
    my_jobs: '我的工作',
    my_orders: '我的${i18n.schema.orders}',
    subprofiles_count: '# ${i18n.schema.subprofiles}',
    // pending_group: '專業',
    pending_status: '狀態',
    remark: '備注',
    order_remarks: '${i18n.schema.order}${i18n.fields.remark}',
    score: '分數',
    scores: '評分',
    question: '問題',
    avg_score: '平均分數',
    action: '動作',
    sender: '發出',
    receiver: '接收',
    recipient: '收件人',
    refs_appointment: '${i18n.schema.appointment}參照',
    profile: '檔案',
    relationship: '關係',
    service_location: '服務地點',
    user_experience: '工作經驗',
    emergency_contact: '緊急聯絡人',
    user_condition: '健康狀況',
    medical_history: '醫療記錄',
    stat: '統計',
    view: '瀏覽',
    click: '點擊',
    creator: '建立者',
    // created_by: '${i18n.fields.creator}',
    first_name: '名',
    last_name: '姓',
    other_name: '其他名稱',
    gender: '性別',
    // hkid: 'HKID',
    mobile: '手機號',
    home_tel: '住宅電話',
    age: '年齡',
    birthday: '生日',
    height: '身高',
    weight: '體重',
    ratio: '比例',
    name: '名稱',
    room: '室',
    flat: '單位',
    floor: '層',
    block: '座',
    building: '大廈',
    street: '街',
    area: '範圍',
    district: '地區',
    // detail: '${i18n.fields.details}',
    required_groups: '所需${i18n.schema.groups}',
    // product_ids: '${i18n.schema.products}',
    value_options: '價錢選項',
    quota: '配額',
    quota_per_user: '每個用戶的配額',
    currency_type: '貨幣',
    currency_amount: '金額',
    used_by: '使用記錄',
    used_at: '時間',
    // member: '${i18n.schema.member}',
    read: '已讀',
    content_type: '類型',
    content: '内容',
    title: '標題',
    code: '代碼',
    sub_type: '子類型',
    admin: '管理員？',
    // expiry_date: '${i18n.fields.expired_at}',
    from: '發出',
    to: '接收',
    tickets: '服務券',
    total_tickets: '${i18n.fields.tickets}總數',
    available_tickets: '可用${i18n.fields.tickets}',
    progress_status: '進度',
    service_date: '服務日期',
    language: '語言',
    notification: '通知',
    sms: '短信',
    app_config: '偏好設定',
    address: '地址',
    custom: '詳細項目',
    customs: '詳細項目',
    // custom_id: '${i18n.fields.custom}',
    // custom_ids: '${i18n.fields.customs}',
    required_custom_types: '必要的${i18n.fields.custom}',
    timeslots: '服務時間',
    owners: '擁有者',
    value: '值',
    description: '描述',
    price_options: '價格選項',
    inventory: '存貨',
    inventory_unlimited: '無限存貨',
    privacy: '系統存取等級',
    days_to_expiry: '保留期限 (日)',
    reason: '原因',
    photo: '圖片',
    transaction_code: '付款碼',
    ref: '參照',
    total_amount: '總金額',
    refund_amount: '退款金額 (應為負數)',
    expected_start_date: '預計開始日期',
    quantity: '數量',
    order_remark: '備註',
    log_write_requests: '記錄有寫入動作的要求',
    caregiver_report: '${i18n.schema.caregiver}報告',
    potential_recipients: '候選${i18n.schema.caregivers}',
    potential_recipient_status: '${i18n.schema.caregiver}${i18n.fields.status}',
    potential_recipients_count: '# ${i18n.schema.caregiver}',
    show_cancelled_recipients: '顯示取消的${i18n.schema.caregivers}',
    transaction_progress: '${i18n.schema.transaction}進度',
    list_order: '排列次序',
    notes: '備注',
    working_history: '工作簡歷',
    working_experience: '工作經驗',
    certificates: '證書',
    marriage_status: '婚姻狀況',
    bank_account: '銀行戶口',
    bank_type: '銀行',
    referral: '從何得知',
    signed_contract: '已簽工作守則',
    working_visa: '已發工作證',
    company: '公司',
    startDate: '開始',
    endDate: '完結',
    fulltime: '全職',
    issuer: '簽發者',
    promotion: '接收宣傳資訊',
    is_promotion: '是否為宣傳資訊？',
    profile_pic: '個人頭像',
    unit_amount: '單價',
    location_fee: '交通费',
    records: '記錄',
    reset_password: '重設密碼',
    new_password: '新密碼',
    confirm_password: '確認密碼',
    payment_gateway_err: '第三方支付網關錯誤碼',
    editable: '可編輯',
    years_of_experience: '年資',
    receivers: '接收者',
    ticket_required: '使用服務券',
    invoice_completed: '已付帳單',
  },
  action: {
    ok: '確定',
    yes: '是',
    no: '否',
    cancel: '取消',
    save: '儲存',
    create: '建立',
    duplicate: '複製',
    add: '新增',
    back: '返回',
    update: '更新',
    upload: '上載',
    upload_replace: '上載並取代',
    reload: '重新整理',
    undo: '復原修改',
    download: '下載',
    assign_job_to_this_member: '指定工作給此${i18n.schema.caregiver}',
    force_assign_job_to_this_member: '強制指定工作給此${i18n.schema.caregiver}',
    force_assign_job: '手動指定${i18n.schema.caregiver}',
    create_$obj: '建立${obj}',
    add_new_$obj: '新增${obj}',
    export_data: '匯出資料',
    export_$obj: '匯出${obj}',
    complete_appointment: '完成${i18n.schema.appointment}',
    show_inactive: '顯示已停用項目',
    send_feedback_to_caregiver: '反饋給${i18n.schema.caregiver}',
    send_feedback_to_client: '反饋給${i18n.schema.client}',
    approve: '批准',
    reject: '拒絕',
    login: '登入',
    logout: '登出',
    read: '已讀',
    unread: '未讀',
    delete: '刪除',
    clear_tokens: '清除登入階段',
    apply: '申請',
    click_to_$action: '按此${action}',
    // finished_interview: '${i18n.fields.finished_interview}',
    distribute_job: '重新分配工作',
    choose_$obj: '選擇${obj} ...',
    reformat_code: '格式化',
    view_invoice: '檢視${i18n.schema.invoice}',
    complete_invoice: '完成${i18n.schema.invoice}',
    import_members: '匯入${i18n.schema.members}',
    update_stat: '更新統計資料',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/hk.js